import { PrilohaDownloadApi } from 'pravo-eu-frontend-ts-axios';
import Uuid from '../model/Uuid';
import { ClientResponse } from '../model/ClientResponse';
import apiConfiguration from './configuration/apiConfiguration';
import { pravoEuPrefixPath } from './configuration/apiConfigurationConstants';

const client = new PrilohaDownloadApi(apiConfiguration(pravoEuPrefixPath));
export const downloadPrilohaByUuid = async (
  uuid: Uuid,
  headers?: object,
):Promise<ClientResponse<Blob>> => {
  const {
    data,
    status,
  } = await client.downloadPriloha(uuid, { ...headers, responseType: 'blob' });
  return {
    data: data && new Blob([data]),
    responseCode: status,
  };
};
